export default __webpack_public_path__ + "static/media/pointMarker-test.76a7ccc9.svg";